var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("h1", { staticClass: "title text-center" }, [
        _vm._v("PERGUNTAS FREQUENTES")
      ]),
      _vm._v(" "),
      _vm._l(_vm.$options.categories, function(category, index) {
        return _c(
          "ul",
          { key: index },
          [
            _c("div", [_vm._v(_vm._s(category.name))]),
            _vm._v(" "),
            _vm._l(category.questions, function(question, index) {
              return _c(
                "li",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      _vm.openQuestion(question)
                    }
                  }
                },
                [_vm._v(_vm._s(question.question))]
              )
            })
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.showQuestion && _vm.question
        ? _c(
            "modal",
            {
              attrs: { title: _vm.question.question, subtitle: "", size: "md" },
              on: {
                close: function($event) {
                  _vm.showQuestion = false
                }
              }
            },
            [
              _c("template", { slot: "body" }, [
                _c("div", {
                  staticStyle: {
                    "font-size": "14px !important",
                    "line-height": "20px"
                  },
                  domProps: { innerHTML: _vm._s(_vm.question.answer) }
                })
              ]),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn bg-purple-outline",
                    on: {
                      click: function($event) {
                        _vm.showQuestion = false
                      }
                    }
                  },
                  [_vm._v("fechar")]
                )
              ])
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0d68ec6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0d68ec6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Questions.vue
// module id = null
// module chunks = 